export default __webpack_public_path__ + "static/media/timothy.a74a2b0d.svg";